module.exports = __webpack_public_path__ + "static/fonts/Mont-Heavy.b4c3eda.woff";